import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { UserProfile } from '../../models/user';
import { FileType } from '../../enums/user/file-type';
import { SessionService } from '../auth/session.service';
import { Role } from '../../models/user-management/role';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AdditionalFilter } from '../../models/rulebook/additional-filter';
import { DeleteItemModel } from '../../models/filter-model/delete-item-model';
import { ImpactOutcome, ImpactOutcomeRatingInput } from '../../models/impact-assessment/impact-outcome';
import { LinkedIdModel } from './../../models/impact-assessment/linked-id-model';
import { DownloadReportModel } from '../../models/view-model/download-report-model';
import { BulkUpdateModel } from './../../models/impact-assessment/bulk-update-model';
import { ImpactAssessment } from './../../models/impact-assessment/impact-assessment';
import { VersionHistoryViewModel } from '../../models/self-assessment/version-history';
import { ImpactOutcomeModel } from '../../models/impact-assessment/impact-outcome-model';
import { VersionHistoryFilter } from '../../models/self-assessment/version-history-filter';
import { ImpactRatingDetailModel } from '../../models/impact-assessment/impact-rating-detail';
import { LinkedAssessmentModel } from '../../models/impact-assessment/linked-assessment-model';
import { ImpactAssessmentFilter } from '../../models/impact-assessment/impact-assessment-filter';
import { ImpactAssessmentDetailsDD } from '../../models/impact-assessment/impact-assessment-details-dd';
import { ImpactAssessmentViewModel } from '../../models/impact-assessment/impact-assessment-view-model';
import { SelfAssessmentDocumentModel } from '../../models/self-assessment/self-assessment-document-model';
import { ImpactAssessmentListViewModel } from '../../models/impact-assessment/impact-assessment-list-view';
import { UpdateImpactAssessmentModel } from '../../models/impact-assessment/update-impact-assessment-model';
import { ImpactAssessmentMasterFilter, ImpactAssessmentMasterFilterT6 } from '../../models/impact-assessment/impact-assessment-master-filter';
import { ImpactAssessmentDetailListModel } from '../../models/impact-assessment/impact-assessment-detail-list-model';
import { StatusModel } from '../../models/impact-assessment/impact-status-model';
import { ImpactAssessmentDropDownList } from '../../models/impact-assessment/impact-assessment-dropdown-list-model';
import { ImpactAssessmentT4DetailsDD } from '../../models/impact-assessment/impact-assessmentT4-details-dd';
import { ImpactAssessment4 } from '../../models/impact-assessment/impact-assessment4';
import { ImpactAssessmentT4DetailListModel } from '../../models/impact-assessment/impact-assessmentT4-detail-list-model';
import { UpdateImpactAssessmentT4Model } from '../../models/impact-assessment/updateImpactAssessmentT4Model';
import { ImpactAssessmentT4ViewModel } from '../../models/impact-assessment/impact-assessmentT4-view-model';
import { ImpactAssessmentFilterT4 } from '../../models/impact-assessment/impact-assessmentT4-filter';
import { BulkUpdateT4Model } from '../../models/impact-assessment/bulk-updateT4-model';
import { ImpactAssessmentT4MasterFilter } from '../../models/impact-assessment/impact-assessmentT4-master-filter';
import { TemplateDetails } from '../../models/impact-assessment/template-details-model';
import { selfTemplateDetails } from '../../models/self-assessment/template';
import { BulkUpdateT5Model, ImpactAssessmentT5, ImpactAssessmentT5DetailListModel, ImpactAssessmentT5DetailsDD, ImpactAssessmentT5DropDownList, ImpactAssessmentT5Filter, ImpactAssessmentT5MasterFilter, ImpactAssessmentT5ViewModel, UpdateImpactAssessmentT5Model } from '../../models/impact-assessment/impact-assessmentT5';
import { ImpactAssessmentT6ViewModel } from '../../models/impact-assessment/impact-assessmentT6-view-modal';
import { ImpactAssessmentDetailsT6DD } from '../../models/impact-assessment/impact-assessment-detailsT6-dd';
import { UpdateImpactAssessmentT6Model } from '../../models/impact-assessment/UpdateImpactAssessmentT6Modael';
import { ImpactAssessmentT6ListDto } from '../../models/impact-assessment/impact-assessmentT6-list';
import { debug } from 'console';
import { ImpactAssessmentFilterT6 } from '../../models/impact-assessment/ImpactAssessmentFilterT6';

@Injectable({ providedIn: 'root' })
export class ImpactService {

  detailTabActive = false;

  constructor(
    private http: HttpClient
  ) {
  }
  public impactAssessmentTemplate3ScrollNotify = new BehaviorSubject<any>('');
  impactAssessmentTemplate3ScrollNotifyObservable$ = this.impactAssessmentTemplate3ScrollNotify.asObservable();
    public impactAssessmentTemplate3ScrollNotifyOther(data: any) {
    if (data) {
        this.impactAssessmentTemplate3ScrollNotify.next(data);
    }
  }
  getImpactAssessment(filter: ImpactAssessmentFilter): Observable<ImpactAssessmentViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentViewModel>(`${environment.config.baseAppURL}/Impact/GetImpactAssessment`, { headers });
  }
  getImpactAssessmentT6(filter: ImpactAssessmentFilterT6): Observable<ImpactAssessmentViewModel> {
    
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentViewModel>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentT6`, { headers });
  }
 
  deleteImpactAssessment(obj: DeleteItemModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(obj));
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/Impact/DeleteImpactAssessment`, { headers });
  }
  deleteImpactAssessmentT6(obj: DeleteItemModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(obj));
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/Impact/DeleteImpactAssessmentT6`, { headers });
  }

  downloadIAReport(obj: DownloadReportModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(obj));
    return this.http.get(`${environment.config.baseAppURL}/Impact/DownloadReport`, { headers, responseType: 'blob' });
  }

  downloadIAReports(downloadReportModel: DownloadReportModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(downloadReportModel));
    return this.http.get(`${environment.config.baseAppURL}/Impact/DownloadReports`, { headers, responseType: 'blob' });
  }

  uploadImportReport(fileToUpload: File, assessmentId: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set('request', assessmentId.toString());
    return this.http.post<any>(`${environment.config.baseAppURL}/Impact/UploadReport`, formData, { headers });
  }

  getImpactAssessmentMasterFilters(): Observable<ImpactAssessmentMasterFilter> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentMasterFilter>(`${environment.config.baseAppURL}/Impact/GetIAMasterFilters` , { headers });
  }

  getImpactAssessmentT6MasterFilters(): Observable<ImpactAssessmentMasterFilterT6> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<ImpactAssessmentMasterFilterT6>(`${environment.config.baseAppURL}/Impact/GetIAT6MasterFilters` , { headers });
  }

  getImpactAssessmentDetails(id: number, filter: string): Observable<ImpactAssessment> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessment>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentDetails?id=` + id + '&filter=' + filter, { headers });
  }
  getImpactAssessmentDetailsT6(id: number,filter: string): Observable<ImpactAssessment> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessment>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentT6Details?id=` + id + '&filter=' + filter, { headers });
  }

  getImpactAssessmentDD(): Observable<ImpactAssessmentDetailsDD> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentDetailsDD>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentDD`, { headers });
  }
  getImpactAssessmentT6DD(): Observable<ImpactAssessmentDetailsT6DD> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentDetailsT6DD>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentT6DD`, { headers });
  }

  updateImpactAssessment(updateAssessment: UpdateImpactAssessmentModel, url: string): Observable<ImpactAssessment> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', url);
    // tslint:disable-next-line:max-line-length
    return this.http.post<ImpactAssessment>(`${environment.config.baseAppURL}/Impact/UpdateImpactAssessment`, updateAssessment, { headers });
  }
  updateImpactAssessmentT6(updateAssessment: UpdateImpactAssessmentT6Model, url: string): Observable<ImpactAssessmentT6ListDto> {
    
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', url);
    // tslint:disable-next-line:max-line-length
    return this.http.post<ImpactAssessmentT6ListDto>(`${environment.config.baseAppURL}/Impact/UpdateImpactAssessmentT6`, updateAssessment, { headers });
  }

  getImpactAssessmentDocuments(id: number): Observable<Array<SelfAssessmentDocumentModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<SelfAssessmentDocumentModel>>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentDocument?id=` + id, { headers });
  }
  getImpactAssessmentDocumentsT6(id: number): Observable<Array<SelfAssessmentDocumentModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<SelfAssessmentDocumentModel>>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentDocumentT6?id=` + id, { headers });
  }
  deleteImpactAssessmentDocument(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/Impact/DeleteImpactAssessmentDocument?id=` + id, { headers });
  }
  deleteImpactAssessmentDocumentT6(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/Impact/DeleteImpactAssessmentDocumentT6?id=` + id, { headers });
  }

  uploadEvidence(fileToUpload: File, fileType: FileType, assessmentId: number, template:number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set('request', fileType.toString() + ';' + assessmentId.toString()).set('template', template.toString());
    return this.http.post<any>(`${environment.config.baseAppURL}/Impact/UploadEvidenceFile`, formData, { headers });
  }
  uploadEvidenceT6(fileToUpload: File, fileType: FileType, assessmentId: number, template:number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    let headers = new HttpHeaders();
    headers = headers.set('request', fileType.toString() + ';' + assessmentId.toString()).set('template', template.toString());
    return this.http.post<any>(`${environment.config.baseAppURL}/Impact/UploadEvidenceFileT6`, formData, { headers });
  }

  downloadEvidence(id: number, template:number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', id.toString()).set('template', template.toString());
    return this.http.get(`${environment.config.baseAppURL}/Impact/DownloadEvidence`, { headers, responseType: 'blob' });
  }
  downloadEvidenceT6(id: number, template:number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', id.toString()).set('template', template.toString());
    return this.http.get(`${environment.config.baseAppURL}/Impact/DownloadEvidenceT6`, { headers, responseType: 'blob' });
  }

  getVersionHistory(filter: VersionHistoryFilter): Observable<VersionHistoryViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<VersionHistoryViewModel>(`${environment.config.baseAppURL}/Impact/GetVersionHistory`, { headers });
  }
  getVersionHistoryT6(filter: VersionHistoryFilter): Observable<VersionHistoryViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<VersionHistoryViewModel>(`${environment.config.baseAppURL}/Impact/GetVersionHistoryT6`, { headers });
  }

  getCurrentUserRole(): Observable<Role> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Role>(`${environment.config.baseAppURL}/Impact/GetRoleInfo`, { headers });
  }

  getImpactOutcome(id: number): Observable<ImpactOutcomeModel[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactOutcomeModel[]>(`${environment.config.baseAppURL}/Impact/GetImpactOutcome?id=` + id, { headers });
  }
  getImpactOutcomeT6(id: number): Observable<ImpactOutcomeModel[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactOutcomeModel[]>(`${environment.config.baseAppURL}/Impact/GetImpactOutcomeT6?id=` + id, { headers });
  }

  saveImpactOutcome(impactOutcome: ImpactOutcome): Observable<ImpactAssessment> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(impactOutcome));
    return this.http.get<ImpactAssessment>(`${environment.config.baseAppURL}/Impact/SaveImpactOutcome`, { headers });
  }

  saveImpactOutcomeT6(impactOutcome: ImpactOutcome): Observable<ImpactAssessment> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(impactOutcome));
    return this.http.get<ImpactAssessment>(`${environment.config.baseAppURL}/Impact/SaveImpactOutcomeT6`, { headers });
  }
  getAllImpactAssessment(filter: AdditionalFilter): Observable<ImpactAssessmentListViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentListViewModel>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentList`, { headers });
  }
  getAllImpactAssessmentT6(filter: AdditionalFilter): Observable<ImpactAssessmentListViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentListViewModel>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentListT6`, { headers });
  }

  saveLinkedAssessment(linkedAssessment: LinkedAssessmentModel): Observable<LinkedAssessmentModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(linkedAssessment));
    return this.http.get<LinkedAssessmentModel>(`${environment.config.baseAppURL}/Impact/AddLinkedAssessment`, { headers });
  }
  saveLinkedAssessmentT6(linkedAssessment: LinkedAssessmentModel): Observable<LinkedAssessmentModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(linkedAssessment));
    return this.http.get<LinkedAssessmentModel>(`${environment.config.baseAppURL}/Impact/AddLinkedAssessmentT6`, { headers });
  }

  getImpactRatingDetail(): Observable<ImpactRatingDetailModel[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactRatingDetailModel[]>(`${environment.config.baseAppURL}/Impact/GetImpactRatingDetails`, { headers });
  }

  getLinkedIds(linkedIds: string): Observable<Array<LinkedIdModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<LinkedIdModel>>(`${environment.config.baseAppURL}/Impact/GetLinkedIds?ids=` + linkedIds, { headers });
  }
  getLinkedIdsT6(linkedIds: string): Observable<Array<LinkedIdModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<LinkedIdModel>>(`${environment.config.baseAppURL}/Impact/GetLinkedIdsT6?ids=` + linkedIds, { headers });
  }

  GetIADetailsHistory(id: number): Observable<ImpactAssessmentDetailListModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentDetailListModel>(`${environment.config.baseAppURL}/Impact/GetIADetailsHistory?id=` + id, { headers });
  }

  iABulkUpdate(bulkUpdate: BulkUpdateModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/Impact/IABulkUpdate`, bulkUpdate, { headers });
  }

  DuplicateImpactAssessment(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/Impact/CopyImpactAssessment?id=` + id, { headers });
  }
  DuplicateImpactAssessmentT6(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/Impact/CopyImpactAssessmentT6?id=` + id, { headers });
  }

  getIAUsers(id: number): Observable<string[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<string[]>(`${environment.config.baseAppURL}/Impact/GetIAUsers?id=` + id, { headers });
  }
  getImpactAssesmentStatus(): Observable<StatusModel[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<StatusModel[]>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentStatus`, { headers });
  }
  getImpactAssesmentDropDownList(jurisdiction : string): Observable<ImpactAssessmentDropDownList> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<ImpactAssessmentDropDownList>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentDropdownList?jurisdictionId=` + encodeURIComponent(jurisdiction), { headers });
  }
  getImpactOutcomeRating(impactOutcome: ImpactOutcomeRatingInput): Observable<ImpactOutcomeModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(impactOutcome));
    return this.http.get<ImpactOutcomeModel>(`${environment.config.baseAppURL}/Impact/CalculateImpactOutcome`, { headers });
  }
  getImpactRatingInfo(): Observable<number[]> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<number[]>(`${environment.config.baseAppURL}/Impact/GetImpactRatingInfo`, { headers });
  }
  saveImpactOutcomeList(impactOutcome: Array<ImpactOutcome>,isOutcomeResultList:boolean,impactAssessmentId:number): Observable<ImpactAssessment> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(impactOutcome));
    return this.http.get<ImpactAssessment>(`${environment.config.baseAppURL}/Impact/UpdateImpactOutcome?isOutcomeResultList=`+isOutcomeResultList+'&impactAssessmentId='+impactAssessmentId, { headers });
  }
  saveImpactOutcomeListT6(impactOutcome: Array<ImpactOutcome>,isOutcomeResultList:boolean,impactAssessmentId:number): Observable<ImpactAssessment> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(impactOutcome));
    return this.http.get<ImpactAssessment>(`${environment.config.baseAppURL}/Impact/UpdateImpactOutcomeT6?isOutcomeResultList=`+isOutcomeResultList+'&impactAssessmentId='+impactAssessmentId, { headers });
  }
  getImpactAssessmentRegulationDetails(Id:number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`${environment.config.baseAppURL}/Impact/GetMergedImpactAssessmentDetails?id=`+Id, { headers });
  }
  GetJurisdictionsList(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<any>(`${environment.config.baseAppURL}/UserManagement/GetJurisdictionsList`, { headers });
  }
  getImpactAssessmentT4Details(id: number, filter: string): Observable<ImpactAssessment4> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessment4>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentT4Details?id=` + id + '&filter=' + filter, { headers });
  }

  getImpactAssessmentT4DD(): Observable<ImpactAssessmentT4DetailsDD> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentT4DetailsDD>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentT4DD`, { headers });
  }

  getIAT4DetailsHistory(id: number): Observable<ImpactAssessmentT4DetailListModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentT4DetailListModel>(`${environment.config.baseAppURL}/Impact/GetIAT4DetailsHistory?id=` + id, { headers });
  }

  updateImpactAssessmentT4(updateAssessment: UpdateImpactAssessmentT4Model, url: string): Observable<ImpactAssessment4> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', url);
    // tslint:disable-next-line:max-line-length
    return this.http.post<ImpactAssessment4>(`${environment.config.baseAppURL}/Impact/UpdateImpactAssessmentT4`, updateAssessment, { headers });
  }

  getVersionHistoryT4(filter: VersionHistoryFilter): Observable<VersionHistoryViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<VersionHistoryViewModel>(`${environment.config.baseAppURL}/Impact/GetVersionHistoryT4`, { headers });
  }

  getImpactAssessmentT4(filter: ImpactAssessmentFilterT4): Observable<ImpactAssessmentT4ViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentT4ViewModel>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentT4`, { headers });
  }

  deleteImpactAssessmentT4(obj: DeleteItemModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(obj));
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/Impact/DeleteImpactAssessmentT4`, { headers });
  }

  duplicateImpactAssessmentT4(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/Impact/CopyImpactAssessmentT4?id=` + id, { headers });
  }

  iABulkUpdateT4(bulkUpdate: BulkUpdateT4Model): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/Impact/IABulkUpdateT4`, bulkUpdate, { headers });
  }

  getImpactAssessmentT4MasterFilters(): Observable<ImpactAssessmentT4MasterFilter> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentT4MasterFilter>(`${environment.config.baseAppURL}/Impact/GetIAT4MasterFilters` , { headers });
  }
  GetAllTypeImpactAssessmentList(filter: ImpactAssessmentFilter): Observable<ImpactAssessmentViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentViewModel>(`${environment.config.baseAppURL}/Impact/GetAllTypeImpactAssessmentList`, { headers });
  }

  //For Impact Assessment Template 5
  getImpactAssessmentT5Details(id: number, filter: string): Observable<ImpactAssessmentT5> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentT5>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentT5Details?id=` + id + '&filter=' + filter, { headers });
  }

  getIAT5DetailsHistory(id: number): Observable<ImpactAssessmentT5DetailListModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentT5DetailListModel>(`${environment.config.baseAppURL}/Impact/GetIAT5DetailsHistory?id=` + id, { headers });
  }

  getImpactAssesmentT5DropDownList(jurisdiction : string): Observable<ImpactAssessmentT5DropDownList> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<ImpactAssessmentT5DropDownList>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentT5DropdownList?jurisdictionId=` + encodeURIComponent(jurisdiction), { headers });
  }
  getImpactAssessmentT5DD(): Observable<ImpactAssessmentT5DetailsDD> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentT5DetailsDD>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentT5DD`, { headers });
  }
  updateImpactAssessmentT5(updateAssessment: UpdateImpactAssessmentT5Model, url: string): Observable<ImpactAssessmentT5> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', url);
    // tslint:disable-next-line:max-line-length
    return this.http.post<ImpactAssessmentT5>(`${environment.config.baseAppURL}/Impact/UpdateImpactAssessmentT5`, updateAssessment, { headers });
  }
  getImpactAssessmentT5(filter: ImpactAssessmentT5Filter): Observable<ImpactAssessmentT5ViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentT5ViewModel>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentT5`, { headers });
  }
  duplicateImpactAssessmentT5(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/Impact/CopyImpactAssessmentT5?id=` + id, { headers });
  }
  iABulkUpdateT5(bulkUpdate: BulkUpdateT5Model): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/Impact/IABulkUpdateT5`, bulkUpdate, { headers });
  }
  deleteImpactAssessmentT5(obj: DeleteItemModel): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(obj));
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/Impact/DeleteImpactAssessmentT5`, { headers });
  }
  getImpactAssessmentT5MasterFilters(): Observable<ImpactAssessmentT5MasterFilter> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<ImpactAssessmentT5MasterFilter>(`${environment.config.baseAppURL}/Impact/GetIAT5MasterFilters` , { headers });
  }
  getVersionHistoryT5(filter: VersionHistoryFilter): Observable<VersionHistoryViewModel> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
    // tslint:disable-next-line:max-line-length
    return this.http.get<VersionHistoryViewModel>(`${environment.config.baseAppURL}/Impact/GetVersionHistoryT5`, { headers });
  }
  //Impact template 5 Document
  getImpactAssessmentDocumentsT5(id: number): Observable<Array<SelfAssessmentDocumentModel>> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<Array<SelfAssessmentDocumentModel>>(`${environment.config.baseAppURL}/Impact/GetImpactAssessmentDocumentT5?id=` + id, { headers });
  }
  deleteImpactAssessmentDocumentT5(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/Impact/DeleteImpactAssessmentDocumentT5?id=` + id, { headers });
  }
}
